











import { Component, Vue, Prop } from "vue-property-decorator";
import { serverBase } from "../apollo";
import { getNationality } from "../../../src/types/countries";

@Component
export default class Flag extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ default: 30 }) width!: number;

  get name() {
    const nation = getNationality(this.value);
    if (nation) return nation.name;
    return "<Invalid nationality>";
  }

  get url() {
    return `${serverBase}/flag/${this.value}`;
  }
}
